import { useAppStore } from '~/stores'

export default async function (query: any, variables?: any) {
  const appStore = useAppStore()
  appStore.loading = true

  let retries = 5
  let e = null

  let data = null

  while (retries > 0) {
    e = null

    data = await useAsyncQuery(query, variables)
      .then((response) => response.data)
      .catch((error) => {
        e = { statusCode: error.status, fatal: true, message: error.message }
      })

    if (data?.value === null) {
      e = { statusCode: 500, fatal: true, message: 'Issue loading the data' }
    }

    if (e) {
      if (e.statusCode === 404) {
        appStore.loading = false

        throw showError(e)
      }

      retries--
    } else {
      break
    }
  }

  appStore.loading = false

  if (e) {
    throw showError(e)
  } else {
    return data?.value
  }
}
